import { DocumentPackageResult, convertFileToDocumentWithFileType } from '@consigli/types';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CardBasedFileDisplay, RESULT_SECTIONS } from '@/components/card-based-file-display';
import { DismissibleDisclaimer } from '@/components/dismissible-disclaimer';
import { isJSONDocumentType } from '@/util/document-check';

interface GeneratedReportsListProps {
  results: DocumentPackageResult[];
}

export const GeneratedReportsList: FC<GeneratedReportsListProps> = ({ results }) => {
  const { t } = useTranslation();

  const documents = useMemo(() => {
    return results
      .filter((result) => !isJSONDocumentType(result.file.filename))
      .map((result) => convertFileToDocumentWithFileType(result.file, result.type));
  }, [results]);

  return (
    <div className="w-full">
      <DismissibleDisclaimer>{t('optimization-tabs.ai-disclaimer')}</DismissibleDisclaimer>
      <div className="flex">
        <CardBasedFileDisplay
          files={documents}
          isFetching={false}
          isPublished={true}
          sections={RESULT_SECTIONS}
        />
      </div>
    </div>
  );
};
